import { subscribeToAnySignal } from 'serviceWorker/events/swSignal';
import { swSignals } from 'serviceWorker/events/swSignals';

export interface SwLifecycleAbortOptions {
  /** Replaced project data stops it too (default); off for data of the user, not of the project (projects). */
  includeProjectSwitch?: boolean;
}

/**
 * Subscribes a running operation (a pull, a sync) to what stops it: logout,
 * changed permissions or replaced project data. Returns the unsubscribe.
 */
export function subscribeSwLifecycleAbort(
  listener: () => void,
  { includeProjectSwitch = true }: SwLifecycleAbortOptions = {}
): () => void {
  const signals = [swSignals.loggedOut, swSignals.permissionsChanged];
  return subscribeToAnySignal(includeProjectSwitch ? [...signals, swSignals.projectDataReplaced] : signals, listener);
}
